export function formatEpoch(value) { //For deployment
  if (!value) return "N/A";

  const numeric = Number(value);
  if (!Number.isFinite(numeric) || numeric <= 0) return value;

  return new Date(numeric * 1000).toLocaleString();
}

export function formatRelativeMix(value) {
  if (!value) return "No recent activity";

  const numeric = Number(value);
  if (!Number.isFinite(numeric) || numeric <= 0) return String(value);

  const diffSeconds = Math.max(0, Math.floor(Date.now() / 1000) - numeric);

  if (diffSeconds < 60) return "Just now";
  if (diffSeconds < 3600) return `${Math.floor(diffSeconds / 60)}m ago`;
  if (diffSeconds < 86400) return `${Math.floor(diffSeconds / 3600)}h ago`;

  return `${Math.floor(diffSeconds / 86400)}d ago`;
}

export function getUserDisplayName(user) {
  if (!user) return "User";
  return user.name.split(' ')[0] || user.email || "User";
}
